/* SaturnRings social landing: lazy media, accessible controls, UTM continuity. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sr-tiktok-landing]');
  if (!root) return;

  var video = root.querySelector('[data-sr-tiktok-video]');
  var toggle = root.querySelector('[data-sr-video-toggle]');
  var toggleLabel = root.querySelector('[data-sr-video-toggle-label]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;
  var userPaused = false;

  function attachVideoSource() {
    if (!video || video.dataset.srSourceAttached === 'true') return;
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.srSourceAttached = 'true';
    video.load();
  }

  function setControlState(playing) {
    if (!toggle || !toggleLabel) return;
    toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    toggleLabel.textContent = playing ? 'Pause video' : 'Play video';
  }

  function playVideo() {
    if (!video || reduceMotion.matches || saveData || userPaused) return;
    attachVideoSource();
    var result = video.play();
    if (result && typeof result.catch === 'function') result.catch(function () { setControlState(false); });
  }

  if (video) {
    video.addEventListener('play', function () { setControlState(true); });
    video.addEventListener('pause', function () { setControlState(false); });

    if (!reduceMotion.matches && !saveData && 'IntersectionObserver' in window) {
      var mediaObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playVideo();
          else video.pause();
        });
      }, { rootMargin: '120px 0px', threshold: 0.25 });
      mediaObserver.observe(video);
    }
  }

  if (toggle && video) {
    toggle.addEventListener('click', function () {
      if (video.paused) {
        userPaused = false;
        attachVideoSource();
        video.play().catch(function () { setControlState(false); });
      } else {
        userPaused = true;
        video.pause();
      }
    });
  }

  var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ttclid'];
  var incoming = new URLSearchParams(window.location.search);
  root.querySelectorAll('[data-sr-preserve-attribution]').forEach(function (link) {
    var url = new URL(link.href, window.location.origin);
    attributionKeys.forEach(function (key) {
      var value = incoming.get(key);
      if (value) url.searchParams.set(key, value);
    });
    link.href = url.pathname + url.search + url.hash;
  });
})();
